module.exports = __webpack_public_path__ + "img/icon_contact_06.bc0a9b2.svg";